import { render } from "./FormatAlignCenter.vue?vue&type=template&id=86c02412"
import script from "./FormatAlignCenter.vue?vue&type=script&lang=js"
export * from "./FormatAlignCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatAlignCenter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86c02412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86c02412', __exports__)) {
    api.reload('86c02412', __exports__)
  }
  
  module.hot.accept("./FormatAlignCenter.vue?vue&type=template&id=86c02412", () => {
    api.rerender('86c02412', render)
  })

}


export default __exports__